import Carousel from 'react-bootstrap/Carousel';
import { motion } from "framer-motion";
import React,{ useState,useEffect } from 'react';
import { trackBannerClick } from "../utils/dataUserpush";
import { NavLink } from 'react-router-dom';
function HomeMobileCarousel({ carousel_data }) {
    const [current_index, setcurrent_index] = useState(0);
    
  useEffect(() => {
    const interval = setInterval(() => {
        current_index === carousel_data.length - 1
        ? setcurrent_index(0)
        : setcurrent_index(current_index + 1);
    }, 3000);
    return () => clearInterval(interval);
  }, [current_index]);

    return (
        <>
            <Carousel fade className='home_mobile_carousel' controls={false} indicators={false} activeIndex={current_index}>
                {
                    carousel_data.map((item) => {
                        const urlParts = item.url.split("/").filter(Boolean);
                        const lastPart = urlParts[urlParts.length - 1] || "Banner Item";
                        const formattedTitle = lastPart.replace(/[-_]/g, " ");
                        return (
                            <Carousel.Item key={item.carousel_id}>
                                   <NavLink to={item.url}
                                onClick={() => trackBannerClick(formattedTitle)}
                                >
                                <img src={item.mobile_image_url} alt='' />
                            </NavLink>
                              
                            </Carousel.Item>
                        )
                    })
                }
            </Carousel>

            <div class="track_indicators">
                {
                    carousel_data.map((indicator_item,index) => {
                        return (
                            <motion.div
                                layout
                                data-isOpen={current_index == index}
                                initial={{ borderRadius: 50 }}
                                className="indicator"
                                onTap={() => setcurrent_index(index)}
                            />
                        )
                    })
                }
            </div>
        </>
    );
}

export default HomeMobileCarousel;